import { render, staticRenderFns } from "./GiftcardBrandList.vue?vue&type=template&id=9914dba8&scoped=true&"
import script from "./GiftcardBrandList.vue?vue&type=script&lang=js&"
export * from "./GiftcardBrandList.vue?vue&type=script&lang=js&"
import style0 from "./GiftcardBrandList.vue?vue&type=style&index=0&id=9914dba8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9914dba8",
  null
  
)

export default component.exports